import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { PreloadingStrategyService } from '@core/services';
import { AUTH_RC } from '@core/constants';
import { PublicVideoResolver } from '@features/public-video/resolvers/public-video.resolver';
import { MY_ACTIVITY_RC } from '@core/constants/routes.constants';

const routes: Routes = [
  {
    path: AUTH_RC.root,
    loadChildren: () => import('@features/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: MY_ACTIVITY_RC.root,
    loadChildren: () => import('@features/activity/activity.module').then(m => m.ActivityModule),
  },
  {
    path: 'on-demand',
    loadChildren: () => import('@features/on-demand/on-demand.module').then(m => m.OnDemandModule),
  },
  {
    path: 'live',
    loadChildren: () => import('@features/live-classes/live-classes.module').then(m => m.LiveClassesModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('@features/profile/profile.module').then(m => m.ProfileModule),
  },
  {
    path: 'public-video/:id',
    loadChildren: () => import('@features/public-video/public-video.module').then(m => m.PublicVideoModule),
    resolve: { video: (route: ActivatedRouteSnapshot) => inject(PublicVideoResolver).resolve(route) },
  },
  {
    path: 'health-check',
    loadChildren: () => import('@features/app-status/app-status.module').then(m => m.AppStatusModule),
  },
  { path: '', redirectTo: `/${AUTH_RC.root}/${AUTH_RC.children.logIn}`, pathMatch: 'full' },
  { path: '**', redirectTo: `/${AUTH_RC.root}/${AUTH_RC.children.logIn}` },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadingStrategyService })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
